import createAxios from './axios_create'
import { getValidToken } from '@/script/storageToken'


const _payedAPI = createAxios({
    baseURL: import.meta.env.VITE_APP_PAYED_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'token ' + import.meta.env.VITE_APP_PAYED_API_TOKEN
    }
    // baseURL: 'http://tumgu-moodle-dev.devpy.ddemo.ru/' + 'webservice/rest/server.php'
})

_payedAPI.interceptors.response.use(response => {
    return Promise.resolve(response)
}, error => {
    return Promise.reject(error)
})

const $payedAPI = (options) => {
    options.method ??= 'POST'

    const staticData = {
        wstoken: getValidToken()
    }

    if (options.method === 'GET') {
        options.params = Object.assign(options.params || {}, staticData)
    } else {
        if (options.data instanceof FormData) {
            for (const name in staticData) {
                options.data.append(name, staticData[name])
                options.headers = { ...options.headers, 'Content-Type': undefined } // Strip default Content-Type from application/json to undefined so axios will derive multipart/form-data later
            }
        } else {
            options.data = Object.assign(options.data || {}, staticData)
        }
    }

    if (options.method === 'PUT') {
        options.method = 'POST'
        options.headers['X-HTTP-Method-Override'] = 'PUT'
    }

    return _payedAPI(options)
}

export { $payedAPI }